"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateHash = calculateHash;
const ethers_1 = require("ethers");
const abiCoder = new ethers_1.ethers.AbiCoder();
function calculateHash(listing) {
    return ethers_1.ethers.keccak256(abiCoder.encode(["tuple(address,address,uint256,uint192,uint256,uint256)"], [[listing.seller, listing.contractAddress, listing.tokenID, listing.units, listing.pricePerUnit, listing.nonce]]));
}
//# sourceMappingURL=calculateHash.js.map